<div class="dialog-header">
    <h2>Importar Excel</h2>
    <button mat-icon-button (click)="closeDialog()" [disabled]="isSaving">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content" style="position: relative;">

    @if (isLoading || isSaving) {
        <div class="spinner-overlay">
            <mat-spinner diameter="40"></mat-spinner>
            <div class="spinner-text">{{ isSaving ? 'Guardando registros...' : 'Procesando archivo...' }}</div>
        </div>
    }

    <!-- Steps bar -->
    <div class="steps-bar">
        <div class="step-item" [class.active]="step === 'upload'" [class.done]="step !== 'upload'"></div>
        <div class="step-item" [class.active]="step === 'preview'" [class.done]="step === 'result'"></div>
        <div class="step-item" [class.active]="step === 'result'"></div>
    </div>

    <!-- STEP 1: Upload -->
    @if (step === 'upload') {
        <div class="upload-zone" (click)="fileInput.click()" [class.has-file]="fileName">
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <div class="upload-text">Arrastra tu archivo Excel o haz clic para seleccionar</div>
            <div class="upload-hint">Formato .xlsx — Layout HITEC</div>
            @if (fileName) {
                <div class="file-name">{{ fileName }}</div>
            }
            <input #fileInput type="file" hidden accept=".xlsx,.xls" (change)="onFileSelected($event)">
        </div>

        <div style="text-align: center; margin-top: 16px;">
            <button mat-stroked-button color="primary" (click)="downloadTemplate()">
                <mat-icon>download</mat-icon> Descargar plantilla
            </button>
        </div>
    }

    <!-- STEP 2: Preview -->
    @if (step === 'preview') {
        <div>
            <!-- Summary cards -->
            <div class="summary-cards">
                <div class="summary-card total">
                    <div class="number">{{ totalRowsInFile }}</div>
                    <div class="label">Total en archivo</div>
                </div>
                <div class="summary-card valid">
                    <div class="number">{{ validNewRows().length }}</div>
                    <div class="label">Nuevos</div>
                </div>
                <div class="summary-card duplicate">
                    <div class="number">{{ _duplicate().length }}</div>
                    <div class="label">Duplicados</div>
                </div>
                <div class="summary-card error">
                    <div class="number">{{ errorRows().length }}</div>
                    <div class="label">Con error</div>
                </div>
            </div>

            @if (missingColumns.length > 0) {
                <div class="missing-cols-warning">
                    <mat-icon>warning</mat-icon>
                    <div class="warning-text">
                        <strong>Columnas requeridas no encontradas:</strong>
                        {{ missingColumns.join(', ') }}
                    </div>
                </div>
            }

            <!-- Tabs -->
            <div class="tab-bar">
                <button class="tab-btn" [class.active]="previewTab === 'valid'" (click)="onTabChange('valid')">
                    Nuevos<span class="badge valid">{{ validNewRows().length }}</span>
                </button>
                <button class="tab-btn" [class.active]="previewTab === 'duplicate'" (click)="onTabChange('duplicate')">
                    Duplicados<span class="badge dup">{{ _duplicate().length }}</span>
                </button>
                <button class="tab-btn" [class.active]="previewTab === 'error'" (click)="onTabChange('error')">
                    Con error<span class="badge error">{{ errorRows().length }}</span>
                </button>
            </div>

            <!-- Valid table -->
            @if (previewTab === 'valid') {
                <div class="table-container">
                    <table mat-table [dataSource]="validDataSource">
                        <ng-container matColumnDef="_rowIndex">
                            <th mat-header-cell *matHeaderCellDef>#</th>
                            <td mat-cell *matCellDef="let row">{{ row._rowIndex }}</td>
                        </ng-container>
                        <ng-container matColumnDef="uuid">
                            <th mat-header-cell *matHeaderCellDef>Folio Fiscal</th>
                            <td mat-cell *matCellDef="let row" [matTooltip]="row.uuid">{{ row.uuid }}</td>
                        </ng-container>
                        <ng-container matColumnDef="folio">
                            <th mat-header-cell *matHeaderCellDef>Factura</th>
                            <td mat-cell *matCellDef="let row">{{ row.folio }}</td>
                        </ng-container>
                        <ng-container matColumnDef="receptorNombre">
                            <th mat-header-cell *matHeaderCellDef>Institución</th>
                            <td mat-cell *matCellDef="let row" [matTooltip]="row.receptorNombre">{{ row.receptorNombre }}</td>
                        </ng-container>
                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef>Total</th>
                            <td mat-cell *matCellDef="let row">{{ row.total | currency:'MXN':'symbol':'1.0-2' }}</td>
                        </ng-container>
                        <ng-container matColumnDef="estatusSistema">
                            <th mat-header-cell *matHeaderCellDef>Estatus (sistema)</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="status-chip">{{ row.estatusSistema }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="estatusOriginal">
                            <th mat-header-cell *matHeaderCellDef>Estatus (original)</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="status-mapped">{{ row.estatusOriginal }}</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="validDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: validDisplayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator #validPaginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
            }

            <!-- Duplicate table -->
            @if (previewTab === 'duplicate') {
                <div class="table-container">
                    <table mat-table [dataSource]="duplicateDataSource">
                        <ng-container matColumnDef="_rowIndex">
                            <th mat-header-cell *matHeaderCellDef>#</th>
                            <td mat-cell *matCellDef="let row">{{ row._rowIndex }}</td>
                        </ng-container>
                        <ng-container matColumnDef="uuid">
                            <th mat-header-cell *matHeaderCellDef>Folio Fiscal</th>
                            <td mat-cell *matCellDef="let row">{{ row.uuid }}</td>
                        </ng-container>
                        <ng-container matColumnDef="folio">
                            <th mat-header-cell *matHeaderCellDef>Factura</th>
                            <td mat-cell *matCellDef="let row">{{ row.folio }}</td>
                        </ng-container>
                        <ng-container matColumnDef="receptorNombre">
                            <th mat-header-cell *matHeaderCellDef>Institución</th>
                            <td mat-cell *matCellDef="let row">{{ row.receptorNombre }}</td>
                        </ng-container>
                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef>Total</th>
                            <td mat-cell *matCellDef="let row">{{ row.total | currency:'MXN':'symbol':'1.0-2' }}</td>
                        </ng-container>
                        <ng-container matColumnDef="estatusOriginal">
                            <th mat-header-cell *matHeaderCellDef>Estatus original</th>
                            <td mat-cell *matCellDef="let row">{{ row.estatusOriginal }}</td>
                        </ng-container>
                        <ng-container matColumnDef="_duplicateReason">
                            <th mat-header-cell *matHeaderCellDef>Motivo</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="dup-reason">Ya existe en el sistema</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="duplicateDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: duplicateDisplayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator #duplicatePaginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
            }

            <!-- Error table -->
            @if (previewTab === 'error') {
                @if (errorRows().length > 0) {
                    <div style="text-align: right; margin: 8px 0;">
                        <button mat-stroked-button color="accent" (click)="downloadErrors()">
                            <mat-icon>download</mat-icon> Descargar errores
                        </button>
                    </div>
                }
                <div class="table-container">
                    <table mat-table [dataSource]="errorDataSource">
                        <ng-container matColumnDef="_rowIndex">
                            <th mat-header-cell *matHeaderCellDef>#</th>
                            <td mat-cell *matCellDef="let row">{{ row._rowIndex }}</td>
                        </ng-container>
                        <ng-container matColumnDef="uuid">
                            <th mat-header-cell *matHeaderCellDef>Folio Fiscal</th>
                            <td mat-cell *matCellDef="let row">{{ row.uuid }}</td>
                        </ng-container>
                        <ng-container matColumnDef="folio">
                            <th mat-header-cell *matHeaderCellDef>Factura</th>
                            <td mat-cell *matCellDef="let row">{{ row.folio }}</td>
                        </ng-container>
                        <ng-container matColumnDef="receptorNombre">
                            <th mat-header-cell *matHeaderCellDef>Institución</th>
                            <td mat-cell *matCellDef="let row">{{ row.receptorNombre }}</td>
                        </ng-container>
                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef>Total</th>
                            <td mat-cell *matCellDef="let row">{{ row.total | currency:'MXN':'symbol':'1.0-2' }}</td>
                        </ng-container>
                        <ng-container matColumnDef="estatusOriginal">
                            <th mat-header-cell *matHeaderCellDef>Estatus original</th>
                            <td mat-cell *matCellDef="let row">{{ row.estatusOriginal }}</td>
                        </ng-container>
                        <ng-container matColumnDef="_errors">
                            <th mat-header-cell *matHeaderCellDef>Errores</th>
                            <td mat-cell *matCellDef="let row">
                                <div class="error-cell">{{ row._errors.join(', ') }}</div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="errorDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: errorDisplayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator #errorPaginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
            }
        </div>
    }

    <!-- STEP 3: Result -->
    @if (step === 'result' && saveResult()) {
        <div class="result-container">
            @if (saveResult()!.failed === 0) {
                <mat-icon class="result-icon success">check_circle</mat-icon>
            } @else if (saveResult()!.success > 0) {
                <mat-icon class="result-icon partial">warning</mat-icon>
            } @else {
                <mat-icon class="result-icon" style="color: #f44336;">error</mat-icon>
            }

            <div class="result-title">
                @if (saveResult()!.failed === 0) { Carga exitosa }
                @else if (saveResult()!.success > 0) { Carga parcial }
                @else { Error en la carga }
            </div>

            <div class="result-detail">
                Se procesaron {{ saveResult()!.success + saveResult()!.failed }} registros del archivo "{{ fileName }}"
            </div>

            <div class="result-stats">
                @if (saveResult()!.success > 0) {
                    <div class="stat ok">
                        <div class="stat-number">{{ saveResult()!.success }}</div>
                        <div class="stat-label">Guardados</div>
                    </div>
                }
                @if (saveResult()!.duplicates > 0) {
                    <div class="stat dup">
                        <div class="stat-number">{{ saveResult()!.duplicates }}</div>
                        <div class="stat-label">Duplicados</div>
                    </div>
                }
                @if (saveResult()!.failed > 0) {
                    <div class="stat fail">
                        <div class="stat-number">{{ saveResult()!.failed }}</div>
                        <div class="stat-label">Fallidos</div>
                    </div>
                }
            </div>

            @if (saveResult()!.operatorsWithoutRfc.length > 0) {
                <div class="operators-no-rfc-warning">
                    <div class="warning-header">
                        <mat-icon>warning</mat-icon>
                        <strong>{{ saveResult()!.operatorsWithoutRfc.length }} operador(es) sin RFC en el catálogo</strong>
                    </div>
                    <div class="warning-body">
                        Los siguientes operadores se agregaron al catálogo sin RFC. Complete el dato en el módulo
                        "Catálogo de Operadores Logísticos" para que las próximas cargas lo completen automáticamente:
                        <ul>
                            @for (name of saveResult()!.operatorsWithoutRfc; track name) {
                            <li>{{ name }}</li>
                            }
                        </ul>
                    </div>
                </div>
            }
        </div>
    }
</div>

<div class="dialog-actions">
    @if (step === 'upload') {
        <button mat-button (click)="closeDialog()">Cancelar</button>
    }

    @if (step === 'preview') {
        <button mat-button (click)="step = 'upload'; fileName = ''">
            <mat-icon>arrow_back</mat-icon> Atrás
        </button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving || validNewRows().length === 0">
            <mat-icon>save</mat-icon>
            Guardar {{ validNewRows().length }} registros nuevos
        </button>
    }

    @if (step === 'result') {
        <button mat-raised-button color="primary" (click)="closeDialog(true)">
            <mat-icon>done</mat-icon> Finalizar
        </button>
    }
</div>
